import { Card, CardActionArea, Divider, Grid, Typography } from '@mui/material'
import React, { useContext, useMemo } from 'react'
import { FaFlagCheckered } from "react-icons/fa";
import { numberFormatterLocale } from 'view/Backend/IncomeExpenses/Ticket/fnTickit';
import { ProviderIncomeDashboard } from '../IncomeDashboard';
import { FaMoneyBill1Wave } from 'react-icons/fa6';


export const CardBoxIncome = ({ year, incomeplan, incomeactual }) => {

    const {
        setIsCheckYear,
        setrYear,
        setArrMonth
    } = useContext(ProviderIncomeDashboard);

    const rationPercent = useMemo(() => {
        return incomeplan === 0 || !incomeplan ? 0 : (incomeactual / incomeplan) * 100;
    }, [incomeactual, incomeplan])

    const handleDisplayYear = () => {
        let nYearCard = parseInt(year) - 543;
        setIsCheckYear(true)
        setrYear(nYearCard)
        let arrMonthId = [];
        for (let index = 1; index <= 12; index++) {
                arrMonthId.push(index + "");
        }
        setArrMonth(arrMonthId)
    }

    return (
        <Card
            className="ag-income_item"
            variant="outlined"
            sx={{
                padding: '0px !important'
            }}
        >
            <CardActionArea
                className="ag-income-item_link"
                onClick={handleDisplayYear}
                sx={{
                    padding: '12px !important'
                }}
            >
                <div className="ag-income-item_bg"></div>
                <Grid container spacing={1} justifyContent={"flex-start"} alignItems={"center"}>
                    <Grid item xs={12} >
                        <Grid container spacing={1} justifyContent={"flex-end"} alignItems={"center"}>
                            <Grid item xs={12} md={11.5} style={{ display: 'flex', alignItems: "center" }}>
                                <FaFlagCheckered className='card-icon' />
                                <span className='card-value'>{numberFormatterLocale(incomeplan, 2)}</span>
                            </Grid>
                            <Grid item xs={12} ><Typography className='card-title'>รายได้ตามแผนงาน</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} >
                        <Divider className='card-divider' />
                    </Grid>
                    <Grid item xs={12} >
                        <Grid container spacing={1} justifyContent={"flex-end"} alignItems={"center"}>

                            <Grid item xs={12} md={11.5} style={{ display: 'flex', alignItems: "center" }}>
                                <FaMoneyBill1Wave className='card-icon' />
                                <span className='card-value'>{numberFormatterLocale(incomeactual, 2)}</span>
                            </Grid>

                            <Grid item xs={12} ><Typography className='card-title'>รายได้รวม</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography className='text-year'>
                    {year}
                </Typography>
                <Typography className='text-percent-dashboard'>
                    {numberFormatterLocale(rationPercent, 2)}%
                </Typography>
            </CardActionArea>
        </Card>
    )
}